import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import BackLink from '../../common/back-link/index';
import Divider from '../../common/divider';
import { connect } from 'react-redux';
import { getAdminOutlet } from '../../../actions/outlet';
import PageTitle from '../../common/page-title';
import OutletRewardDetails from './outlet-reward-details';
import StaffMemberList from './staff-member-list';
import { Redirect } from 'react-router-dom';
import ToastMessage from '../../common/toast-message';
import { getVoucherTypesSetting } from '../../../actions/voucher';
import OutletDetails from './outlet-details';
import { destandard } from '../../../utils/commonFunctions';
import ActiveIncentives from './active-incentives';

class OutletView extends Component {
  componentWillMount() {
    this.props.dispatch(getAdminOutlet(this.props.match.params.id));
  }

  componentDidMount() {
    this.props.dispatch(getVoucherTypesSetting());
  }

  notFoundErrorRender() {
    const errors = this.props.errors;

    if (typeof errors === "string" && errors === 'Not Found') {
      toast.error(<ToastMessage iconStyle="error" message={`Outlet not found by id ${this.props.match.params.id}`}/>);

      return true;
    } else {
      return false;
    }
  }

  filterDeliveryFields(attributes) {
    const deliveryFields = [
      'delivery-address-1',
      'delivery-address-2',
      'delivery-address-3',
      'use-delivery-address',
      'delivery-eircode',
      'delivery-county',
      'delivery-town'
    ];

    let delivery = {};

    deliveryFields.forEach(d => {
      if (attributes.hasOwnProperty(d)) {
        delivery[d] = attributes[d];
      }
    });

    return destandard(delivery);
  }

  render() {
    let rewards = {};
    let nominations = [];
    let voucherType = {};
    let voucherDenomination = {};
    const { id } = this.props.match.params;
    const { loading, voucherFetched, outlet, voucher } = this.props;
    const { attributes: details } = outlet;
    const rewardDetails = details['rewards-details'];
    const { incentives } = details;

    if (this.notFoundErrorRender()) {
      return <Redirect to="/admin/outlets"/>;
    }

    if (loading || !voucherFetched) {
      return <p>Loading...</p>;
    }

    const delivery = this.filterDeliveryFields(details);

    if (details['reward-store']) {
      voucherType = ({
        label: rewardDetails['voucher-type'] !== null && rewardDetails['voucher-type'].name,
        value: rewardDetails['voucher-type'] !== null &&  rewardDetails['voucher-type'].id
      });
      voucherDenomination = ({
        label: rewardDetails['voucher-denomination'] !== null && rewardDetails['voucher-denomination'].variant,
        value: rewardDetails['voucher-denomination'] !== null && rewardDetails['voucher-denomination'].id
      });

      rewards = details['rewards-details'];

      voucher.voucher_types.forEach(v => {
        nominations[v.id] = v.attributes['voucher-denominations']
      });
    }

    return (
      <div className="fluid">
        <div className="container-fluid">
          <Row>
            <Col md={12}>

              <BackLink href="/admin/outlets"/>

              <PageTitle>VIEW OUTLET</PageTitle>

              <Row>
                <Col md={12}>
                  <h3>
                    Outlet details
                  </h3>
                  <OutletDetails id={outlet.id} details={outlet.attributes}/>
                </Col>
              </Row>

              <Divider/>
              {
                details && details['reward-store'] &&
                <div>
                  <h3>Rewards Details</h3>
                  <OutletRewardDetails
                    delivery={delivery}
                    reward={rewards}
                    voucher={voucher}
                    nominations={nominations}
                    selectedType={voucherType}
                    selectedDenomination={voucherDenomination}
                    id={id}
                  />
                  <h3>Active Incentives</h3>
                  <ActiveIncentives
                    incentives={incentives}
                  />
                  <Divider/>
                </div>
              }
              <h3>Staff Details</h3>
              <StaffMemberList
                owner={details.owner}
                staffMembers={outlet.relationships["staff-members"].data}
              />
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    voucher: state.voucher,
    voucherFetched: state.voucher.fetched,
    outlet: state.store.outlet,
    loading: state.store.fetching && !state.store.fetched,
    errors: state.store.errors,
  };
}

export default connect(mapStateToProps)(OutletView);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/index.jsx